<template>
  <BaseModal
    class="modal-confirm"
    v-bind="attributes"
    v-on="$listeners"
  >
    <BaseTitle
      v-if="title"
      v-bind="title"
    />
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'ModalConfirm',
  components: {
    BaseModal,
    BaseTitle,
  },
  props: {
    title: {
      type: Object,
      default: null,
    },
    agreeText: {
      type: String,
      default() {
        return this.$t('main.yes');
      },
    },
    disagreeText: {
      type: String,
      default() {
        return this.$t('main.no');
      },
    },
    isInversed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attributes() {
      const actions = [
        {
          text: this.disagreeText,
          action: this.disagree,
          theme: this.isInversed ? 'secondary' : undefined,
        },
        {
          text: this.agreeText,
          action: this.agree,
          theme: this.isInversed ? undefined : 'secondary',
        },
      ];
      return {
        hasCloseButton: false,
        isMiddle: true,
        actions: this.isInversed ? actions.reverse() : actions,
        ...this.$attrs,
      };
    },
  },
  methods: {
    disagree() {
      this.$emit('disagree');
    },
    agree() {
      this.$emit('agree');
    },
  },
};
</script>

<style lang="stylus">
.modal-confirm
  .modal__content
    width 40em
    padding-left 1.25em
    padding-right @padding-left
</style>
